import * as ActionTypes from '../actions';
import {LOGOUT} from "../actions";
import {errorParser} from "../helpers/functions";
import {LOCATION_CHANGE} from "connected-react-router";

const defaultState = {
    pendingChanges: [],
    fetchingPendingChanges: false,
    patchingId: '',
    errorMessage: '',
    errorItemId: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.CLEAR_PENDING_CHANGES_ERROR_STATE:
            return {
                ...state,
                errorMessage: defaultState.errorMessage,
                errorItemId: defaultState.errorItemId
            };
        case ActionTypes.CHANGE_PENDING_CHANGE_STATE:
            return {
                ...state,
                patchingId: action.payload.pendingChangeId,
                errorMessage: defaultState.errorMessage,
                errorItemId: defaultState.errorItemId
            };
        case ActionTypes.CHANGE_PENDING_CHANGE_STATE_SUCCESS:
            return {
                ...state,
                patchingId: defaultState.patchingId,
                pendingChanges: state.pendingChanges.filter(item => item.id !== action.payload.pendingChangeId)
            };
        case ActionTypes.CHANGE_PENDING_CHANGE_STATE_FAILED:
            return {
                ...state,
                patching: false,
                patchingId: defaultState.patchingId,
                errorMessage: action.payload.message,
                errorItemId: action.payload.pendingChangeId
            };
        case ActionTypes.MODERATE_PENDING_CHANGE:
            return {
                ...state,
                patchingId: action.payload.sendBody.applicationAnswerPendingChangeId,
                errorItemId: defaultState.errorItemId,
                errorMessage: defaultState.errorMessage
            };
        case ActionTypes.MODERATE_PENDING_CHANGE_SUCCESS:
            return {
                ...state,
                patchingId: defaultState.patchingId
            };
        case ActionTypes.MODERATE_PENDING_CHANGE_FAILED:
            let errorMessage = '';
            try {
                errorMessage = errorParser(action.payload.response);
                if(!errorMessage){
                    errorMessage = "Failed to update.";
                }
            } catch (e) {
                errorMessage = 'Failed to update.'
            }
            return {
                ...state,
                patchingId: defaultState.patchingId,
                errorMessage: errorMessage,
                errorItemId: state.patchingId
            };
        case ActionTypes.FETCH_PENDING_CHANGES:
            return {
                ...state,
                fetchingPendingChanges: true
            };
        case ActionTypes.FETCH_PENDING_CHANGES_SUCCESS:
            return {
                ...state,
                pendingChanges: action.payload.body,
                fetchingPendingChanges: false
            };
        case ActionTypes.FETCH_PENDING_CHANGES_FAILED:
            return {
                ...state,
                fetchingPendingChanges: false
            };
        case ActionTypes.CHANGE_PENDING_CHANGES_STORE:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case ActionTypes.CHANGE_ACTIVE_TAB:
            return action.payload === "pendingChanges" ? state : defaultState;
        case LOCATION_CHANGE:
            return defaultState;
        case LOGOUT:
            return defaultState;
        default:
            return state;
    }
}